module.exports = __webpack_public_path__ + "static/media/new-banner-mtn.65a14f15.jpg";